import { AcquiringChannel, Catalogue, Delivery, PaymentMethodCode } from '../types';
import { getCatalogueItemFromCatalogue } from './get-device-from-catalogue';

export const setPaymentMethod = (allowedPaymentMethods: PaymentMethodCode[]) => {
  if (allowedPaymentMethods.length == 1) {
    switch (allowedPaymentMethods[0]) {
      case PaymentMethodCode.RENTAL:
        return PaymentMethodCode.RENTAL;

      case PaymentMethodCode.ZERO:
        return PaymentMethodCode.ZERO;

      default:
        return null;
    }
  }

  return null;
};

const paymentMethodConfig = new Map<PaymentMethodCode, AcquiringChannel[]>([
  [
    PaymentMethodCode.RENTAL,
    [
      AcquiringChannel.rentOnlineFicaOnline,
      AcquiringChannel.thirdPartyChannel,
      AcquiringChannel.zeroRentOnlineFicaOnline,
    ],
  ],
  [PaymentMethodCode.ONLINE_PAYMENT, [AcquiringChannel.buyOnlineFicaOnline]],
  [PaymentMethodCode.PAYMENT_LINK, [AcquiringChannel.thirdPartyChannel]],
  [PaymentMethodCode.PAYFLEX, [AcquiringChannel.buyOnlineFicaOnline]],
  [PaymentMethodCode.PAYFLEX_LINK, [AcquiringChannel.thirdPartyChannel]],
  [
    PaymentMethodCode.CASH,
    [
      AcquiringChannel.buyInstoreFicaInstore,
      AcquiringChannel.buyInstoreFicaOnline,
      AcquiringChannel.vodacomBusiness,
      AcquiringChannel.thirdPartyChannel,
    ],
  ],
  [
    PaymentMethodCode.ZERO,
    [
      AcquiringChannel.rentOnlineFicaOnline,
      AcquiringChannel.buyOnlineFicaOnline,
      AcquiringChannel.thirdPartyChannel,
      AcquiringChannel.buyInstoreFicaInstore,
      AcquiringChannel.buyInstoreFicaOnline,
      AcquiringChannel.vodacomBusiness,
    ],
  ],
]);

export const mapPaymentMethodCode = (
  acquiringChannel: AcquiringChannel,
  allowedPaymentMethods: PaymentMethodCode[],
  remotePaymentEnabled: boolean,
  isBrokerJourney: boolean,
) => {
  const paymentMethodCode = findKeyByValue<PaymentMethodCode, AcquiringChannel>(
    paymentMethodConfig,
    acquiringChannel,
  );

  if (
    !remotePaymentEnabled &&
    acquiringChannel === AcquiringChannel.thirdPartyChannel &&
    isBrokerJourney
  ) {
    return PaymentMethodCode.CASH;
  }

  if (paymentMethodCode && allowedPaymentMethods.includes(paymentMethodCode)) {
    return paymentMethodCode === PaymentMethodCode.ONLINE_PAYMENT &&
      !remotePaymentEnabled &&
      isBrokerJourney
      ? PaymentMethodCode.CASH
      : paymentMethodCode;
  }
};

function findKeyByValue<T, U>(map: Map<T, U[]>, searchValue: U) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const resultEntry = Array.from(map.entries()).find(([_, values]) => values.includes(searchValue));

  return resultEntry ? resultEntry[0] : null;
}

export const getDeliveriesPaymentMethodCodes = (catalogue: Catalogue, deliveries: Delivery[]) => {
  return deliveries.flatMap((delivery) => {
    const { solutions } = delivery;
    const _solutions = solutions.filter((sol) => sol.productId);
    const allowedPaymentMethods = _solutions.flatMap((solution) => {
      const device = getCatalogueItemFromCatalogue(
        catalogue,
        solution.productId,
        solution.acquiringChannel,
      );

      if (!device) {
        throw new Error(
          `Integration revamp: getDeliveriesPaymentMethodCodes: unknown device encountered: product id: ${solution.productId}, acq channel: ${solution.acquiringChannel}`,
        );
      }

      return device?.device.allowedPaymentMethods;
    });

    return allowedPaymentMethods.filter((value, index, array) => array.indexOf(value) === index);
  });
};
